"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ArrowDropLeft2_exports = {};
__export(ArrowDropLeft2_exports, {
  default: () => ArrowDropLeft2_default
});
module.exports = __toCommonJS(ArrowDropLeft2_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.36328 9.82031C5.49349 9.6901 5.63672 9.59245 5.79297 9.52734C5.96224 9.44922 6.14453 9.41016 6.33984 9.41016C6.52214 9.41016 6.69141 9.44922 6.84766 9.52734C7.01693 9.59245 7.17318 9.6901 7.31641 9.82031C7.44661 9.95052 7.54427 10.1003 7.60938 10.2695C7.67448 10.4258 7.70703 10.6016 7.70703 10.7969C7.70703 10.9922 7.67448 11.1745 7.60938 11.3438C7.54427 11.5 7.44661 11.6497 7.31641 11.793C7.17318 11.9232 7.01693 12.0273 6.84766 12.1055C6.69141 12.1706 6.52214 12.2031 6.33984 12.2031C6.14453 12.2031 5.96224 12.1706 5.79297 12.1055C5.63672 12.0273 5.49349 11.9232 5.36328 11.793C5.22005 11.6628 5.11589 11.513 5.05078 11.3438C4.98568 11.1745 4.95312 10.9922 4.95312 10.7969C4.95312 10.6146 4.98568 10.4453 5.05078 10.2891C5.11589 10.1198 5.22005 9.96354 5.36328 9.82031ZM13.6836 9.82031C13.8268 9.6901 13.9766 9.59245 14.1328 9.52734C14.3021 9.44922 14.4779 9.41016 14.6602 9.41016C14.8555 9.41016 15.0312 9.44922 15.1875 9.52734C15.3568 9.59245 15.5065 9.6901 15.6367 9.82031C15.7799 9.95052 15.8841 10.1003 15.9492 10.2695C16.0143 10.4258 16.0469 10.6016 16.0469 10.7969C16.0469 10.9922 16.0078 11.1745 15.9297 11.3438C15.8646 11.5 15.7669 11.6497 15.6367 11.793C15.5065 11.9232 15.3568 12.0273 15.1875 12.1055C15.0312 12.1706 14.8555 12.2031 14.6602 12.2031C14.4779 12.2031 14.3021 12.1706 14.1328 12.1055C13.9766 12.0273 13.8268 11.9232 13.6836 11.793C13.5534 11.6628 13.4557 11.513 13.3906 11.3438C13.3255 11.1745 13.293 10.9922 13.293 10.7969C13.293 10.6146 13.3255 10.4453 13.3906 10.2891C13.4557 10.1198 13.5534 9.96354 13.6836 9.82031ZM9.52344 9.82031C9.65365 9.6901 9.79688 9.59245 9.95312 9.52734C10.1224 9.44922 10.3047 9.41016 10.5 9.41016C10.6823 9.41016 10.8516 9.44922 11.0078 9.52734C11.1771 9.59245 11.3333 9.6901 11.4766 9.82031C11.6068 9.95052 11.7044 10.1003 11.7695 10.2695C11.8477 10.4258 11.8867 10.6016 11.8867 10.7969C11.8867 10.9922 11.8477 11.1745 11.7695 11.3438C11.7044 11.5 11.6068 11.6497 11.4766 11.793C11.3464 11.9232 11.1966 12.0273 11.0273 12.1055C10.8581 12.1706 10.6823 12.2031 10.5 12.2031C10.3177 12.2031 10.1419 12.1706 9.97266 12.1055C9.81641 12.0273 9.66667 11.9232 9.52344 11.793C9.39323 11.6628 9.28906 11.513 9.21094 11.3438C9.14583 11.1745 9.11328 10.9922 9.11328 10.7969C9.11328 10.6146 9.14583 10.4453 9.21094 10.2891C9.28906 10.1198 9.39323 9.96354 9.52344 9.82031ZM3.83984 16.9102H17.1602V16.0898H3.83984V16.9102Z",
      fill: "currentColor"
    }
  )
);
const SvgArrowDropLeft2 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ArrowDropLeft2_default = SvgArrowDropLeft2;
